@if (open()) {
  <app-admin-modal title="Request Feature" size="xl" (closed)="onClose()">
    <div class="fr-create">
      <label class="cg-admin-field">
        <span class="cg-admin-field__label">Title <span class="fr-create__req">*</span></span>
        <input class="cg-input" type="text" [(ngModel)]="title" name="title" maxlength="200" [disabled]="busy()" placeholder="Bulk Applicant Import" />
      </label>

      <div class="fr-create__row">
        <label class="cg-admin-field">
          <span class="cg-admin-field__label">Type</span>
          <select class="cg-select" [(ngModel)]="type" name="type" [disabled]="busy()">
            @for (t of types; track t) {
              <option [value]="t">{{ typeLabels[t] }}</option>
            }
          </select>
        </label>
        <label class="cg-admin-field">
          <span class="cg-admin-field__label">Priority</span>
          <select class="cg-select" [(ngModel)]="priority" name="priority" [disabled]="busy()">
            @for (p of priorities; track p) {
              <option [value]="p">{{ priorityLabels[p] }}</option>
            }
          </select>
        </label>
      </div>

      <label class="cg-admin-field">
        <span class="cg-admin-field__label">Description <span class="fr-create__req">*</span></span>
        <textarea class="cg-textarea" rows="6" [(ngModel)]="description" name="description" [disabled]="busy()" placeholder="Describe the feature or defect in detail…"></textarea>
      </label>

      <div class="fr-create__upload">
        <span class="cg-admin-field__label">Attachments</span>
        <p class="fr-create__hint">PNG, JPG, JPEG, PDF — max 10 MB each</p>
        <input
          #fileInput
          type="file"
          class="fr-create__file-input"
          multiple
          accept=".png,.jpg,.jpeg,.pdf,image/png,image/jpeg,application/pdf"
          (change)="onFilesSelected($event)"
          [disabled]="busy()"
        />
        <app-admin-button variant="secondary" type="button" [disabled]="busy()" (click)="fileInput.click()">
          Choose files
        </app-admin-button>

        @if (files().length > 0) {
          <div class="fr-create__previews">
            @for (item of files(); track item.file.name + item.file.size; let i = $index) {
              <div class="fr-create__preview">
                @if (item.previewUrl) {
                  <img [src]="item.previewUrl" [alt]="item.file.name" />
                } @else {
                  <span class="fr-create__pdf">PDF</span>
                }
                <span class="fr-create__fname">{{ item.file.name }}</span>
                <button type="button" class="fr-create__remove" [disabled]="busy()" (click)="removeFile(i)">Remove</button>
              </div>
            }
          </div>
        }
      </div>

      @if (fieldError()) {
        <p class="fr-create__error" role="alert">{{ fieldError() }}</p>
      }
      @if (error()) {
        <p class="fr-create__error" role="alert">{{ error() }}</p>
      }

      <div class="fr-create__actions">
        <app-admin-button variant="cancel" type="button" [disabled]="busy()" (click)="onClose()">Cancel</app-admin-button>
        <app-admin-button variant="primary" type="button" [disabled]="busy()" (click)="onSubmit()">
          {{ busy() ? 'Submitting…' : 'Submit Request' }}
        </app-admin-button>
      </div>
    </div>
  </app-admin-modal>
}
